import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IProcessState } from 'shared/interfaces/redux'
import { loadSystemConfig } from 'redux/actions'
import { systemProcessSelector } from 'redux/selectors'

interface IConfigLoaderProps {
    children: React.ReactNode
}

export const ConfigLoader: React.FunctionComponent<IConfigLoaderProps> = ({ children }) => {
    const dispatch = useDispatch()
    const process: IProcessState = useSelector(systemProcessSelector)
    const isLoading = Boolean(process.isLoading)

    useEffect(() => {
        if (typeof window !== 'undefined' && window.location.pathname !== '/') {
            dispatch(loadSystemConfig.request())
        }
    }, [dispatch])

    return <>{typeof children === 'function' ? children(isLoading) : children}</>
}
